import api from "../axiosInstance";

export const getPartnerProfileStatus = async () => {
  try {
    const response = await api.get("/partner/profile/status");
    return response;
  } catch (error) {
    console.error("Get partner completion status error:", error);
    throw error;
  }
};

export const updatePartnerProfile = async (data) => {
  try {
    const response = await api.put("/partner/profile/complete", data);
    return response;
  } catch (error) {
    console.error("Update partner profile error:", error);
    throw error;
  }
};
